import { useState } from 'react';
import {
  Box,
  Tabs,
  Tab,
  Typography,
  Paper,
} from '@mui/material';
import PartPayments from '../components/payments/PartPayments';
import MonthlySettlements from '../components/payments/MonthlySettlements';
import WorkerLedger from '../components/payments/WorkerLedger';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`payment-tabpanel-${index}`}
      aria-labelledby={`payment-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `payment-tab-${index}`,
    'aria-controls': `payment-tabpanel-${index}`,
  };
}

export default function PaymentsPage() {
  const [tabValue, setTabValue] = useState(0);
  const [ledgerInit, setLedgerInit] = useState<{ workerId?: string, startDate?: string, endDate?: string }>({});

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  const openLedgerForWorker = (workerId: string) => {
    const now = new Date();
    const start = new Date(now.getFullYear(), now.getMonth() - 1, 1);
    const startStr = start.toISOString().split('T')[0];
    const endStr = now.toISOString().split('T')[0];
    setLedgerInit({ workerId, startDate: startStr, endDate: endStr });
    setTabValue(2);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Typography variant="h4" sx={{ mb: 3 }}>
        Payments Management
      </Typography>

      <Paper sx={{ width: '100%', mb: 2 }}>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          aria-label="payment management tabs"
          sx={{ borderBottom: 1, borderColor: 'divider' }}
        >
          <Tab label="Part Payments" {...a11yProps(0)} />
          <Tab label="Monthly Settlements" {...a11yProps(1)} />
          <Tab label="Worker Ledger" {...a11yProps(2)} />
        </Tabs>

        <TabPanel value={tabValue} index={0}>
          <PartPayments />
        </TabPanel>
        <TabPanel value={tabValue} index={1}>
          <MonthlySettlements onOpenLedger={openLedgerForWorker} />
        </TabPanel>
        <TabPanel value={tabValue} index={2}>
          <WorkerLedger initialWorkerId={ledgerInit.workerId} initialStartDate={ledgerInit.startDate} initialEndDate={ledgerInit.endDate} />
        </TabPanel>
      </Paper>
    </Box>
  );
} 